import { getServiceRequestStatusLabel } from 'domains-work-order-type-contracts';
import { ChipListItem, ChipStyle } from 'components/ads/chipSelect/types';
import { ServiceRequestStatusEnum } from 'domains/workOrder/serviceRequest/components/types/serviceRequestStatus';

const CHIP_STYLE_BY_STATUS: Record<string, ChipStyle> = {
  [ServiceRequestStatusEnum.Created]: ChipStyle.Green,
  [ServiceRequestStatusEnum.Accepted]: ChipStyle.Pink,
  [ServiceRequestStatusEnum.InProgress]: ChipStyle.Blue,
  [ServiceRequestStatusEnum.OnHold]: ChipStyle.Yellow,
  [ServiceRequestStatusEnum.Closed]: ChipStyle.Grey,
  [ServiceRequestStatusEnum.Declined]: ChipStyle.Grey,
  [ServiceRequestStatusEnum.Cancelled]: ChipStyle.Grey,
  [ServiceRequestStatusEnum.Complete]: ChipStyle.Grey,
};

export type StatusDropdownViewModel = {
  selected: ChipListItem;
  options: ChipListItem[];
};

function toStatusOption(status: string): ChipListItem {
  return {
    label: getServiceRequestStatusLabel(status) ?? status,
    value: status,
    type: CHIP_STYLE_BY_STATUS[status] ?? ChipStyle.Red,
  };
}

export function createStatusDropdownViewModel(
  status: string | null | undefined,
  nextStatuses: (string | null)[] | null | undefined
): StatusDropdownViewModel {
  const selected = toStatusOption(status ?? '');
  const nextOptions = (nextStatuses ?? [])
    .filter((nextStatus): nextStatus is string => !!nextStatus)
    .map(toStatusOption);

  return { selected, options: [...nextOptions, selected] };
}
